// <x-transition> only finds its child two animation frames after it connects, and opening or closing it before then
// throws on the missing child. It announces itself with an `x-transition-add` event as it connects, so note it here
// until those frames have run (ours are queued after its own). Load this before '@captaincodeman/transition' defines
// the element, so the elements already on the page are noted too.
const settingUp = new WeakSet()

document.addEventListener('x-transition-add', ({ target }) => {
  settingUp.add(target)
  queueMicrotask(() => requestAnimationFrame(() => requestAnimationFrame(() => settingUp.delete(target))))
})

// Before setup, only the `open` attribute is set: <x-transition> shows or hides its child from it once set up.
export function setTransitionOpen(transition, open) {
  if (settingUp.has(transition)) {
    transition.toggleAttribute('open', open)
  } else {
    transition.open = open
  }
}
